import React from 'react';
import { GenericCard } from '@ui-components/Card/GenericCard';

interface PointsProgressBarProps {
    pointsUsed: number;
    pointsTotal: number;
    pctConsumed: number;
}

function fmt(n: number): string {
    return n.toLocaleString('en-US', { maximumFractionDigits: 2 });
}

const PointsProgressBar: React.FC<PointsProgressBarProps> = ({
    pointsUsed,
    pointsTotal,
    pctConsumed,
}) => {
    const pct = Math.min(pctConsumed, 100);
    let barColor = 'bg-semantic-bg-success-primary';
    if (pct > 75) barColor = 'bg-semantic-bg-danger-primary';
    else if (pct > 50) barColor = 'bg-semantic-bg-warning-primary';

    return (
        <GenericCard
            isCollapsible={false}
            variant="primary"
            className="mb-4"
            bodyContent={
                <>
                    <div className="flex items-center justify-between mb-2">
                        <span className="text-xs font-semibold text-semantic-text-secondary uppercase tracking-wider">
                            {fmt(pointsUsed)} / {fmt(pointsTotal)} pts consumed
                        </span>
                        <span className="text-sm font-bold text-semantic-text-primary">
                            {pct}%
                        </span>
                    </div>
                    <div className="w-full h-3 bg-semantic-bg-secondary rounded-sm overflow-hidden">
                        <div
                            className={`h-full ${barColor} rounded-sm transition-all duration-500`}
                            style={{ width: `${Math.max(pct, 2)}%` }}
                        />
                    </div>
                </>
            }
        />
    );
};

export default PointsProgressBar;
